import { HttpClient } from './types';


export const createPaymentService = (httpClient: HttpClient) => {
  const getEndpoint = (url: string): string => `/pagos${url}`;

  return {
    getPaymentOptions: <TPaymentOption = any>(): Promise<TPaymentOption[]> => {
      return httpClient.get<TPaymentOption[]>(getEndpoint(''));
    },
  };
};

